import { createSelector } from 'reselect';

var getTheme = function getTheme(state) {
  return state.theme;
};

export var getThemeSelector = createSelector(getTheme, function (theme) {
  return theme;
});